module.exports = __webpack_public_path__ + "img/Labatt-Logo-SM.6e7e18e9.png";